// Widget-Plugin: SimpleSignal
// Widget-Plugin: SimpleSignal
// Widget-Plugin: SimpleSignal
vcDashboardRegistry.register("simplesignal", {
    defaults: { w: 12, h: 6, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: true, pushOthers: false, category: "simplevalues", get menuLabel() { return vcDashboardResources.get("menuSimpleValues"); }, menuOrder: 2 },
    settingsDefaults: { SignalIds: [], IsCumulated: false, Interval: 0, ChartType: "spline", ComparisonMode: 0, ComparisonOffset: -1, PriceCo2: 0 },
    get popupTitle() { return vcDashboardResources.get("singleValueSettings"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-simplesignal-wrapper'>" + item.title + "</div>");
    },
    buildParams: function (settings, status) {
        return vcDashboardPopup.buildChartParams(settings, status);
    },
    loadChart: function ($item, settings) {
        var resolved = vcDashboardPopup.resolveEffectiveSettings($item, settings);
        var obj = $item.find(".dashboard-simplesignal-wrapper");
        obj.empty();
        obj.height($item.height() - 20);

        var params = this.buildParams(resolved.effectiveSettings, resolved.status)

        obj.DashboardSimpleSignal({ invokeType: "addVisualBase", parameter: params.Param, signalParameter: params.SignalParam });
       
    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
    buildFields: function (currentSettings, $el) {
        var signalOptions = vcDashboardPopup.getSignalOptions($el);
        var fields = [];
        if (signalOptions.length) {
            fields.push({ key: "SignalIds", label: vcDashboardResources.get("signal"), type: "searchselect", options: signalOptions, arrayIndex: 0 });
        }
        //fields.push({ key: "IsCumulated", label: vcDashboardResources.get("cumulated"), type: "checkbox" });
        fields.push({ key: "Interval", label: vcDashboardResources.get("interval"), type: "select", options: [{value:0,text:vcDashboardResources.get("inheritFromMenu")},{value:1,text:vcDashboardResources.get("singleValues")},{value:2,text:vcDashboardResources.get("dailyValues")},{value:3,text:vcDashboardResources.get("monthlyValues")}] });
        //fields.push({ key: "ComparisonMode", label: vcDashboardResources.get("comparisonPeriod"), type: "select", options: [{value:0,text:vcDashboardResources.get("noComparison")},{value:1,text:vcDashboardResources.get("inheritFromMenu")},{value:2,text:vcDashboardResources.get("comparisonSpecific")}] });
        //fields.push({ key: "ComparisonOffset", label: "", suffix: vcDashboardResources.get("periods"), type: "number", dependsOn: { key: "ComparisonMode", value: 2 } });
        fields.push({ key: "PriceCo2", label: vcDashboardResources.get("priceCo2"), type: "select", options: [{value:0,text:vcDashboardResources.get("noSelection")},{value:1,text:vcDashboardResources.get("prices")},{value:2,text:vcDashboardResources.get("co2")}] });
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});
